import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from "react";

/** Media query that matches when the OS/browser is set to dark mode */
const DARK_MODE_MEDIA_QUERY = "(prefers-color-scheme: dark)";

/** Resolves the current OS color scheme to a theme mode */
function getSystemThemeMode() {
  return window.matchMedia(DARK_MODE_MEDIA_QUERY).matches ? "dark" : "light";
}

/**
 * Returns the theme mode ("dark" | "light") preferred by the operating
 * system / browser. Reacts to live changes of the OS color scheme while
 * the app is open.
 */
export function useSystemThemeMode() {
  const $ = _c(2);
  const [systemThemeMode, setSystemThemeMode] = useState(getSystemThemeMode);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      const mediaQuery = window.matchMedia(DARK_MODE_MEDIA_QUERY);
      const handleChange = function handleChange(event) {
        setSystemThemeMode(event.matches ? "dark" : "light");
      };
      mediaQuery.addEventListener("change", handleChange);
      return () => mediaQuery.removeEventListener("change", handleChange);
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  return systemThemeMode;
}